import { render } from "./AdminLocations.vue?vue&type=template&id=01b2e97f&scoped=true&ts=true"
import script from "./AdminLocations.vue?vue&type=script&lang=ts"
export * from "./AdminLocations.vue?vue&type=script&lang=ts"

import "./AdminLocations.vue?vue&type=style&index=0&id=01b2e97f&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b2e97f"]])

export default __exports__